// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"Breadcrumbs_breadcrumbs__1UOSS","container":"Breadcrumbs_container__3pCd0","ancestor":"Breadcrumbs_ancestor__1yciZ","current":"Breadcrumbs_current__1yBp0"};